import { MarkerType, ReactFlow, useEdgesState, useNodesState } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import './style.css';
import styles from 'react-day-picker/style.css';

const FlowSteps = () => {
    const nodes = [
        {
            id: 'topLeft',
            position: { x: 268, y: -8 }, // Center top
            data: {},
            sourcePosition: 'top',
            targetPosition: 'bottom',
        },
        {
            id: 'topRight',
            position: { x: 318, y: -8}, // Same as top
            data: {},
            sourcePosition: 'bottom',
            targetPosition: 'top',
        },
        {
            id: 'left',
            position: { x: 220, y: 70 }, // Bottom left
            data: {},
            sourcePosition: 'top',
            targetPosition: 'bottom',
        },
        {
            id: 'right',
            position: { x: 366, y: 70 }, // Bottom right
            data: {},
            sourcePosition: 'bottom',
            targetPosition: 'top',
        },
    ];

    const edges = [
        {
            id: 'left-to-top',
            source: 'left',
            target: 'topLeft',
            type: 'straight',
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,  // Increased from default size
                height: 20, // Increased from default size
                color: 'green'
            },
            style: {
                stroke: 'green',
                strokeDasharray: '4',
                strokeWidth: 0.5,
            },
            animated: true,
        },
        {
            id: 'right-to-top',
            source: 'topRight',
            target: 'right',
            type: 'straight',
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,  // Increased from default size
                height: 20, // Increased from default size
                color: 'green'
            },
            style: {
                stroke: 'green',  
                strokeDasharray: '4',
                strokeWidth: 0.5,
            },
            animated: true,
        },
    ];

    const [rfNodes] = useNodesState(nodes);
    const [rfEdges] = useEdgesState(edges);

    return (
        <div className="relative mx-auto h-[300px] w-[700px] mt-[-100px]">
            {/* React Flow just for arrows */}
            <ReactFlow
                nodes={rfNodes}
                edges={rfEdges}
                fitView
                panOnDrag={false}
                zoomOnScroll={false}        
                zoomOnPinch={false}          
                zoomOnDoubleClick={false} 
                nodesDraggable={false}
                nodesConnectable={false}
                elementsSelectable={false}
                proOptions={{ hideAttribution: true }}
            />

            {/* Top Node */}
            <div className="absolute top-[20px] left-[280px] z-10 flex flex-col items-center">
                <div className="flex h-24 w-24 items-center justify-center rounded-full border border-dashed border-black dark:border-gray-500">
                    <div className="rounded-full bg-[#EFEFEF] p-2">
                        <img src="/assets/gloab.png" className="m-1 object-contain object-center" />
                    </div>
                </div>
                <p className="mt-2 w-[140px] text-center text-xs">Setup Your Own Domains</p>
            </div>

            {/* Left Node */}
            <div className="absolute top-[204px] left-[90px] z-10 flex flex-col items-center">
                <div className="flex h-24 w-24 items-center justify-center rounded-full border border-dashed border-black dark:border-gray-500">
                    <div className="rounded-full bg-[#EFEFEF] p-2">
                        <img src="/assets/gallery.png" className="m-1 object-contain object-center" />
                    </div>
                </div>
                <p className="mt-2 w-[140px] text-center text-xs">Setup Your Own Email Template</p>
            </div>

            {/* Right Node */}
            <div className="absolute top-[204px] left-[460px] z-10 flex flex-col items-center">
                <div className="flex h-24 w-24 items-center justify-center rounded-full border border-dashed border-black dark:border-gray-500">
                    <div className="rounded-full bg-[#EFEFEF] p-2">
                        <img src="/assets/email-message.png" className="m-1 object-contain object-center" />
                    </div>
                </div>
                <p className="mt-2 w-[160px] text-center text-xs">
                    Setup Campaign
                    <br />
                    using domain and templates
                </p>
            </div>
        </div>
    );
};

export default FlowSteps;
